import { render, staticRenderFns } from "./TimeslotContainer.vue?vue&type=template&id=b967bb80"
import script from "./timeslot-container.js?vue&type=script&lang=js&external"
export * from "./timeslot-container.js?vue&type=script&lang=js&external"
import style0 from "./timeslot-container.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports